countMap